import React from 'react';
import { phoneCountries } from '../../constants/phoneCountries';

interface PhoneCountrySelectorProps {
  value: string;
  onChange: (iso2: string) => void;
  id?: string;
  disabled?: boolean;
  className?: string;
}

const PhoneCountrySelector: React.FC<PhoneCountrySelectorProps> = ({
  value,
  onChange,
  id,
  disabled = false,
  className,
}) => {
  return (
    <select
      id={id}
      value={value || 'SA'}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
      className={`w-full px-3 py-3 border rounded-lg bg-white text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#a57a6a]/20 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed ${className || 'border-slate-300'}`}
      dir="rtl"
    >
      {phoneCountries.map((country) => (
        <option key={country.iso2} value={country.iso2}>
          {`${country.flag} ${country.nameAr} (${country.dialCode})`}
        </option>
      ))}
    </select>
  );
};

export default PhoneCountrySelector;
